import React from "react";

import './styles.scss';

import {getUserMainPage} from "../../../../../emitters/account";
import {Link} from "../../../../../router";
import AppIcon from "../../../../icons/Lunu";

export const Logo = ({className, text}) => (
  <Link className={['logo', className].join(' ')} href={getUserMainPage()} data-testid="headerLogo">
    <div className="logo__svg">
      <AppIcon />
    </div>
    <div className="logo__text">
      {text}
    </div>
  </Link>
);

export const ConsoleLogo = (props) => (
  <Logo {...props} text="Console" />
);
export const MerchantLogo = () => (
  <Logo className="logo--merchant" text="Console" />
);
export const ReferralLogo = () => (
  <Logo className="logo--merchant" text="Referral" />
);
export const AdminLogo = (props) => (
  <Logo {...props} text="Admin" />
)
